<template>
  <v-list dense>
    <v-list-group class="resultado-select" v-model="mostrarOpciones" no-action
                  :append-icon="opciones.length > 1 ? '$expand' : ''"
                  @click="seMuestranLasOpciones()">
      <template v-slot:activator>
        <v-list-item-content>
          <v-list-item-title class="title pb-1" v-if="resultadoOpcion">
            {{ resultadoOpcion['texto'] }}
            <v-tooltip bottom class="pl-2">
              <template v-slot:activator="{on}">
                <v-icon v-on="on" small>mdi-information-outline</v-icon>
              </template>
              <span>{{ resultadoOpcion['info'] }}</span>
            </v-tooltip>

          </v-list-item-title>
          <v-divider v-if="!mostrarOpciones" color="secondary"></v-divider>
        </v-list-item-content>
      </template>

      <div v-for="(opcion, i) in opciones" :key="i">
        <v-list-item v-if="opcion !== resultadoOpcion" @click="seleccionaOpcion(opcion)" link>
          <v-list-item-content>
            <v-list-item-title class="title">
              {{ opcion['texto'] }}
              <v-tooltip bottom class="pl-2">
                <template v-slot:activator="{on}">
                  <v-icon v-on="on" small>mdi-information-outline</v-icon>
                </template>
                <span>{{ opcion['info'] }}</span>
              </v-tooltip>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </div>
    </v-list-group>
  </v-list>
</template>

<script>
export default {
  name: "EscenarioSeleccionComponente",
  data: function () {
    return {
      mostrarOpciones: false,
      resultadoOpcion: null
    }
  },
  props: {
    opciones: {type: Array, required: true}
  },
  mounted() {
    this.resultadoOpcion = this.opciones[1]
  },
  methods: {
    seleccionaOpcion(opcion) {
      this.mostrarOpciones = false;
      this.resultadoOpcion = opcion
      this.$emit("change", opcion);
    },
    seMuestranLasOpciones() {
      this.mostrarOpciones = true;
    },
  }
}
</script>

<style lang="scss">

.title {
  font-size: 1.2rem !important;
  font-weight: bolder !important;
}

.resultado-select {
  .v-list-group__header {
    padding: 0;
  }

  .v-list-item__content {
    color: #40108e !important;

    .v-icon {
      color: #40108e !important;
    }
  }
}

</style>